import { render, staticRenderFns } from "./ServicePackages.vue?vue&type=template&id=2e338eda&"
import script from "./ServicePackages.vue?vue&type=script&lang=js&"
export * from "./ServicePackages.vue?vue&type=script&lang=js&"
import style0 from "./ServicePackages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports